import { render, staticRenderFns } from "./AncillaryServices.vue?vue&type=template&id=c168235c&scoped=true"
import script from "./AncillaryServices.vue?vue&type=script&lang=js"
export * from "./AncillaryServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168235c",
  null
  
)

export default component.exports